import { proxy } from "valtio/vanilla";
export type AlertsStore = {
  show: boolean;
  title: string;
  message: string;
};

export const alertsStore = proxy<AlertsStore>({
  show: false,
  title: "",
  message: "",
});
